import "./polyfills";
import "./assets/DefaultStyles.css";
import "./assets/Fonts";
import "./services/firebase/FirebaseService";
import "raven-js";

import * as React from "react";
import * as ReactDOM from "react-dom";

import App from "./App";
import { unregister } from "./registerServiceWorker";


ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
unregister();



// WEBPACK FOOTER //
// ./src/index.tsx